<template>
    <DsModal
        :is-open="isOpen"
        :title="$t('declineFeedbackModal.title')"
        size="med"
        show-close
        @close="handleClose"
    >
        <template #default>
            <DsStack>
                <DsText variant="display-alt">
                    {{ $t('declineFeedbackModal.title') }}
                </DsText>

                <DsText variant="body">
                    {{ $t('declineFeedbackModal.description') }}
                </DsText>

                <DsCheckbox
                    v-model="selectedReasons.didntMeanToAdd"
                    :label="$t('declineFeedbackModal.didntMeanToAdd')"
                />

                <DsCheckbox
                    v-model="selectedReasons.notEnoughInfo"
                    :label="$t('declineFeedbackModal.notEnoughInfo')"
                />

                <DsCheckbox
                    v-model="selectedReasons.somethingElse"
                    :label="$t('declineFeedbackModal.somethingElse')"
                />

                <DsInline space="spacing-200">
                    <DsFilledButton
                        :disabled="
                            !selectedReasons.didntMeanToAdd &&
                                !selectedReasons.notEnoughInfo &&
                                !selectedReasons.somethingElse
                        "
                        @click="handleDecline"
                    >
                        {{ $t('declineFeedbackModal.decline') }}
                    </DsFilledButton>
                    <DsTextButton @click="handleClose">
                        {{ $t('declineFeedbackModal.cancel') }}
                    </DsTextButton>
                </DsInline>
            </DsStack>
        </template>
    </DsModal>
</template>

<script>
export default {
    name: 'DeclineFeedbackModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
    },

    emits: ['close', 'decline'],

    data() {
        return {
            selectedReasons: {
                didntMeanToAdd: false,
                notEnoughInfo: false,
                somethingElse: false,
            },
        };
    },

    watch: {
        isOpen(value) {
            if (value) {
                this.resetForm();
            }
        },
    },

    methods: {
        handleClose() {
            this.$emit('close');
        },

        handleDecline() {
            this.$emit('decline', { ...this.selectedReasons });
            this.resetForm();
            this.handleClose();
        },

        resetForm() {
            this.selectedReasons = {
                didntMeanToAdd: false,
                notEnoughInfo: false,
                somethingElse: false,
            };
        },
    },
};
</script>

<i18n>
{
    "en": {
        "declineFeedbackModal": {
            "title": "Can you tell us more?",
            "description": "It would help us to know why you decided against granting this Keap Partner access to your app.",
            "didntMeanToAdd": "I didn't mean to add the partner",
            "notEnoughInfo": "There's not enough information for me to make a decision",
            "somethingElse": "Something else",
            "decline": "Decline access",
            "cancel": "Cancel"
        }
    }
}
</i18n>
